import { render, staticRenderFns } from "./BlendMaterial2.vue?vue&type=template&id=52cc9bb8&scoped=true"
import script from "./BlendMaterial2.vue?vue&type=script&lang=js"
export * from "./BlendMaterial2.vue?vue&type=script&lang=js"
import style0 from "./BlendMaterial2.vue?vue&type=style&index=0&id=52cc9bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc9bb8",
  null
  
)

export default component.exports